module.exports = __webpack_public_path__ + "img/header-title02.f11c34c4.png";